var lists_default = {
  "fontElementMap": "Us8et",
  "orderedlist": "Rh3f2",
  "bulletedlist": "KWjzF",
  "listItem": "RexvY"
};
export {
  lists_default as default
};
//# sourceMappingURL=lists-scss.js.map
